import { $ } from '@/Engine/stateInstance';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { Door } from '@/Engine/Door';
import { Window } from '@/Engine/Window';

export function onTempItems() {
    const configuratorStore = useConfigurationStore();
    let success = false;

    if ($.selectionBox.target instanceof Window) {
        configuratorStore.setWindowPositionByUUID($.selectionBox.target.uuid, $.selectionBox.target.position.toArray(), $.selectionBox.side);
        return;
    }
    if ($.selectionBox.target instanceof Door) {
        configuratorStore.setDoorPositionByUUID($.selectionBox.target.uuid, $.selectionBox.target.position.toArray(), $.selectionBox.side);
        return;
    }
    if ($.selectionBoxForBox.target) {
        configuratorStore.setBoxPositionByUUID($.selectionBoxForBox.target.uuid, $.selectionBoxForBox.target.position.toArray());
        return;
    }

    // TODO в configuratorStore нужно добавить функцию которая
    // примет сразу полки, модули и рельсы
    // а тут надо написать функцию которая соберет raw со всех полок, модулей и рельсов



    if ($.tempKit) {
        configuratorStore.addKit($.tempKit.wardrobe);
        // $.tempKit.wardrobe.rails.forEach((rail) => {
        //     configuratorStore.addRailGroup(rail);
        // });
        // $.tempKit.wardrobe.modules.forEach((module) => {
        //     configuratorStore.addModule(module);
        // });
        // $.tempKit.wardrobe.shelves.forEach((shelf) => {
        //     configuratorStore.addShelf(shelf);
        // });
        success = true;
        $.tempKit = null;
        $.tempModule = null;
        $.tempShelf = null;
        $.tempRail = null;
        $.updated = false;
        return;
    }


    // if ($.tempShelf) {
    //     const tempShelfOnScene = $.wardrobe.getShelfByUUID('temp');
    //     if (tempShelfOnScene)
    //         $.tempShelf = tempShelfOnScene.raw;
    //     // $.tempModuleChild.uuid = crypto.randomUUID();
    //     if ($.tempModule) {
    //         const tempModuleOnScene = $.wardrobe.getModuleByUUID('temp');
    //         if (tempModuleOnScene)
    //             $.tempModule = tempModuleOnScene.raw;
    //         if ($.tempModule.uuid === 'temp')
    //             $.tempModule.uuid = crypto.randomUUID();
    //         $.tempShelf.rackModuleUUID = $.tempModule.uuid;
    //     }
    //
    //     if ($.tempRail && $.tempModule) {
    //         const tempRailOnScene = $.wardrobe.getRailByUUID('temp');
    //         if (tempRailOnScene)
    //             $.tempRail = tempRailOnScene.raw;
    //
    //         if ($.tempRail.uuid === 'temp')
    //             $.tempRail.uuid = crypto.randomUUID();
    //         $.tempModule.railGroupUUID = $.tempRail.uuid;
    //     }


        // configuratorStore.addShelf($.tempShelf);
        // $.tempModuleChildParentUUID = null;
        // $.tempShelf = null;
        // success = true;
    // }
    // console.log($.wardrobe.raw);
    configuratorStore.addKit($.wardrobe.raw);
    $.tempModule = null;
    $.tempShelf = null;
    $.tempRail = null;
    $.updated = false;
    // if ($.tempModule) {
    //     if ($.tempRail?.uuid === 'temp') {
    //         $.tempRail.uuid = crypto.randomUUID();
    //         $.tempModule.railGroupUUID = $.tempRail.uuid;
    //     }
    //     configuratorStore.addModule($.tempModule);
    //     $.tempModule = null;
    //     success = true;
    // }
    //
    // if ($.tempRail) {
    //     configuratorStore.addRailGroup($.tempRail);
    //     $.tempRail = null;
    //     success = true;
    // }

    return success;
}
